import Analytics from '@monolith/legacy/services/analytics';
import UserClick from '@monolith/legacy/services/analytics/events/user-click.event';

export type ProductImageSwipeDirection = 'next' | 'previous';

/**
 * PRICE-4: mobile-only tracking to measure whether retailers use the product-tile image
 * gallery. Fires once per swipe that changes the displayed image (desktop uses hover, which
 * is not tracked). The swipe gesture is touch-only, so this event is inherently mobile-only.
 */
export const trackProductImageSwiped = (params: {
  productId: number;
  position: number;
  pageNumber: number;
  direction: ProductImageSwipeDirection;
}): Promise<void> =>
  Analytics.track(
    new UserClick({
      component: 'product_tile',
      action: 'product_tile_image_swiped',
      id_product: params.productId,
      position: params.position,
      page_number: params.pageNumber,
      direction: params.direction,
    })
  );
